import { createReducer, on } from '@ngrx/store';
import { IndTemplateBuilderActions } from './indTemplateBuilder.actions';
import { IndTemplateBuilderState, initialIndTemplateBuilderState } from './indTemplateBuilder.state';

export const indTemplateBuilderReducer = createReducer(
  initialIndTemplateBuilderState,

  // Clear any stale template while the new one loads
  on(IndTemplateBuilderActions.loadTemplate, (state): IndTemplateBuilderState => ({ ...state, template: null })),
  on(
    IndTemplateBuilderActions.loadTemplateSuccess,
    (state, { template }): IndTemplateBuilderState => ({ ...state, template }),
  ),

  on(
    IndTemplateBuilderActions.updateTemplateInformation,
    (state, { templateName, templateDescription }): IndTemplateBuilderState =>
      state.template ? { ...state, template: { ...state.template, templateName, templateDescription } } : state,
  ),
  // Shallow-merge of top-level config keys — pages send complete nested objects (see actions file).
  on(
    IndTemplateBuilderActions.updateTemplateConfig,
    (state, { templateConfig }): IndTemplateBuilderState =>
      state.template?.templateConfig
        ? {
            ...state,
            template: {
              ...state.template,
              templateConfig: { ...state.template.templateConfig, ...templateConfig },
            },
          }
        : state,
  ),

  on(IndTemplateBuilderActions.saveTemplate, (state): IndTemplateBuilderState => ({ ...state, saving: true })),
  on(IndTemplateBuilderActions.saveTemplateSuccess, (state): IndTemplateBuilderState => ({ ...state, saving: false })),
  on(IndTemplateBuilderActions.saveTemplateFailure, (state): IndTemplateBuilderState => ({ ...state, saving: false })),

  on(IndTemplateBuilderActions.resetStore, (): IndTemplateBuilderState => initialIndTemplateBuilderState),
);
